import type { StoryElement, StoryElementKind } from '@historyjki/shared';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

const KIND_LABEL: Record<StoryElementKind, string> = {
  character: 'Character',
  place: 'Place',
  object: 'Object',
};

interface UnreviewedElementsModalProps {
  open: boolean;
  elements: StoryElement[];
  onJumpToDefine: () => void;
  onSplitAnyway: () => void;
  onDismiss: () => void;
}

export function UnreviewedElementsModal({
  open,
  elements,
  onJumpToDefine,
  onSplitAnyway,
  onDismiss,
}: UnreviewedElementsModalProps) {
  return (
    <Modal open={open} onClose={onDismiss} title="Review story elements first?">
      <div className="unreviewed-elements-modal">
        <p className="unreviewed-elements-modal__intro">
          These elements were auto-extracted but haven't been edited yet.
          Reviewing them in Define gives the AI more to work with — but you
          can split anyway.
        </p>

        <ul className="unreviewed-elements-modal__list">
          {elements.map((el) => (
            <li key={el.id} className="unreviewed-elements-modal__item">
              <span className="unreviewed-elements-modal__kind">
                {KIND_LABEL[el.kind]}
              </span>
              <span className="unreviewed-elements-modal__name">{el.name}</span>
            </li>
          ))}
        </ul>

        <div className="unreviewed-elements-modal__actions">
          <Button variant="ghost" onClick={onDismiss}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={onJumpToDefine}>
            Edit in Define
          </Button>
          <Button variant="primary" onClick={onSplitAnyway}>
            Split anyway
          </Button>
        </div>
      </div>
    </Modal>
  );
}
